const PrismLogo = ({ className = 'w-8 h-8' }) => (
  <svg
    viewBox="0 0 60 100"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 16.7l30 16.7V0L0 16.7z" fill="#1270e2" />
    <path d="M30 33.3L0 16.7V50l30-16.7z" fill="#975fce" />
    <path d="M30 66.7L0 50v33.3l30-16.6z" fill="#fa5776" />
    <path d="M0 50l30 16.7V33.3L0 50z" fill="#fb962e" />
    <path d="M60 50L30 33.3v33.3L60 50z" fill="#ffcd19" />
    <path d="M30 33.3L60 50V16.7L30 33.3z" fill="#47eeaa" />
    <path d="M60 16.7L30 0v33.3l30-16.6z" fill="#58c1ff" />
    <path d="M0 83.3L30 100V66.7L0 83.3z" fill="#2cbfc7" />
  </svg>
);

export default PrismLogo;
